import { Component, type ReactNode } from "react";

// デプロイ直後に古いタブが新しいチャンクを読めず真っ白になる問題への保険。
// - 動的import（コード分割）の読み込み失敗＝アプリ更新の合図とみなし、一度だけ自動再読み込み。
// - それ以外のエラーは白画面ではなく「再読み込み」案内を表示する。
const isChunkError = (e: unknown): boolean => {
  const m = String((e as { message?: string })?.message ?? e ?? "");
  return /dynamically imported module|Importing a module script failed|Failed to fetch|ChunkLoadError|Loading chunk|error loading dynamically/i.test(m);
};
// 短時間の再読み込みループを防ぐ時間ガード（10秒以内の連続リロードはしない）。
const reloadOnce = (): boolean => {
  try {
    const last = Number(sessionStorage.getItem("lb_reload_ts") || 0);
    if (Date.now() - last > 10000) { sessionStorage.setItem("lb_reload_ts", String(Date.now())); window.location.reload(); return true; }
  } catch { /* sessionStorage不可でも致命的でない */ }
  return false;
};

export default class ErrorBoundary extends Component<{ children: ReactNode }, { err: unknown }> {
  state = { err: null as unknown };
  static getDerivedStateFromError(err: unknown) { return { err }; }
  componentDidCatch(err: unknown) { if (isChunkError(err)) reloadOnce(); }
  render() {
    if (this.state.err) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-3 p-6 text-center">
          <div className="text-2xl">🔄</div>
          <p className="text-lg font-semibold text-gray-800">画面を読み込めませんでした</p>
          <p className="max-w-sm text-sm text-gray-500">アプリが更新された可能性があります。再読み込みすると最新版で開きます。</p>
          <button className="btn-primary" onClick={() => { try { sessionStorage.removeItem("lb_reload_ts"); } catch { /* noop */ } window.location.reload(); }}>再読み込み</button>
        </div>
      );
    }
    return this.props.children;
  }
}
